<!--
システムエラー画面
URL：/error
表示条件：なし
-->

<template>
  <v-container>
    <div class="text-h4 mt-8">システムエラー</div>
    <v-card flat min-height="400">
      <v-card-text> システムエラーが発生しました </v-card-text>
    </v-card>
    <v-row justify="center" class="mt-8" style="text-align: center">
      <v-col cols="12">
        <v-btn width="200" color="grey white--text" @click.stop="back"
          >戻る</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Account from "@/logic/api/account.js";

export default {
  methods: {
    back() {
      Account.signOut(this.$store, this.$router);
    },
  },
  computed: {
    tosAgreed() {
      return this.$store.getters.isTosAgree;
    },
  },
};
</script>

<style></style>
